import React, { useEffect, useState } from 'react';
import { Avatar } from 'antd';
import { httpClient } from 'util/Api';

const CompanyUserAvatar = ({ record, fallback, onClick }) => {
  const [base64, setBase64] = useState(record.Avatar || '');
  const [avatarFile, setAvatarFile] = useState(null);

  useEffect(() => {
    let cancelled = false;
    if (!record.HasAvatar || record.Avatar) {
      return () => { cancelled = true; };
    }

    // 列表只返回 HasAvatar，图片内容通过认证请求独立加载，避免拖大列表 JSON。
    httpClient
      .get(`/Admin/CompanyUser/Avatar/${record.CompanyUserId}`, { responseType: 'blob' })
      .then(({ data }) => {
        if (cancelled || !data || data.size === 0) {
          return;
        }
        const file = new File([data], 'avatar.png', {
          type: data.type || 'application/octet-stream',
          lastModified: Date.now()
        });
        const reader = new FileReader();
        reader.onloadend = () => {
          if (!cancelled && typeof reader.result === 'string') {
            setBase64(reader.result.split(',')[1] || '');
            setAvatarFile(file);
          }
        };
        reader.readAsDataURL(data);
      })
      .catch(() => {
        // 头像加载失败不影响列表，继续显示姓名首字母。
      });

    return () => { cancelled = true; };
  }, [record.CompanyUserId, record.HasAvatar, record.Avatar]);

  return (
    <Avatar
      className="gx-pointer"
      size={24}
      alt=""
      src={base64 ? `data:image/jpeg;base64,${base64}` : undefined}
      onClick={() => {
        // 已有头像时等待文件加载完成，避免用户过早提交导致误清空头像。
        if (!record.HasAvatar || base64) {
          onClick(base64, avatarFile);
        }
      }}
    >
      {!base64 && fallback}
    </Avatar>
  );
};

export default CompanyUserAvatar;
